import React from 'react';
import LoginForm from './LoginForm';

const Login: React.FC = (): JSX.Element => <LoginForm application="medivi" />;

export default Login;
